import { create } from 'zustand';
import type { Id } from '@pk/shared';

export interface Toast {
  id: number;
  kind: 'info' | 'error' | 'chronicle';
  text: string;
}

export type MapMode = 'realm' | 'terrain' | 'armies';

interface UiState {
  toasts: Toast[];
  pushToast: (kind: Toast['kind'], text: string) => void;
  dismissToast: (id: number) => void;
  wsConnected: boolean;
  setWsConnected: (v: boolean) => void;
  /** Army selected on the map / military screen for "move here". */
  selectedArmyId: Id | null;
  selectArmy: (id: Id | null) => void;
  mapMode: MapMode;
  setMapMode: (m: MapMode) => void;
  /** Command ids already toasted (avoid duplicates between WS and polling). */
  toastedCommands: Set<string>;
  endedDismissed: boolean;
  dismissEnded: () => void;
}

let toastSeq = 1;

export const useUi = create<UiState>((set, get) => ({
  toasts: [],
  pushToast: (kind, text) => {
    const id = toastSeq++;
    set((s) => ({ toasts: [...s.toasts.slice(-3), { id, kind, text }] }));
    setTimeout(() => get().dismissToast(id), kind === 'error' ? 7000 : 4500);
  },
  dismissToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  wsConnected: false,
  setWsConnected: (v) => set({ wsConnected: v }),
  selectedArmyId: null,
  selectArmy: (id) => set({ selectedArmyId: id }),
  mapMode: 'realm',
  setMapMode: (m) => set({ mapMode: m }),
  toastedCommands: new Set(),
  endedDismissed: false,
  dismissEnded: () => set({ endedDismissed: true }),
}));
